import { render, staticRenderFns } from "./moreInfo.vue?vue&type=template&id=56ceb30a&scoped=true&"
import script from "./moreInfo.vue?vue&type=script&lang=js&"
export * from "./moreInfo.vue?vue&type=script&lang=js&"
import style0 from "./moreInfo.vue?vue&type=style&index=0&id=56ceb30a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ceb30a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56ceb30a')) {
      api.createRecord('56ceb30a', component.options)
    } else {
      api.reload('56ceb30a', component.options)
    }
    module.hot.accept("./moreInfo.vue?vue&type=template&id=56ceb30a&scoped=true&", function () {
      api.rerender('56ceb30a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personalCenter/order/moreInfo.vue"
export default component.exports